export default __webpack_public_path__ + "static/speech-drilling-0e92cf777663329be2e33577b031b14f.mp3";